import React, { createContext, PropsWithChildren, useContext } from "react";


const PropertyLocaleContext = createContext<string[]>([]);

/**
 * Obtains the configured languages for a given property.
 *
 * When called this will always give undefined on the first pass as it does the request to the backend.
 *
 * If the call fails, this will return an empty array. If successful, the configured locales for the property
 */
export function usePropertyLocales(): string[] {
  return useContext(PropertyLocaleContext);
}

export interface PropertyLocalesProviderProps {
  locales: string[];
}

export function PropertyLocalesProvider({ locales, children}: PropsWithChildren<PropertyLocalesProviderProps>) {
  return (
    <PropertyLocaleContext.Provider value={locales}>
      {children}
    </PropertyLocaleContext.Provider>
  );
}